export class AssigneeAppletDtoModel {
    assignee_hdr_table: string;
    assignee_guid: string;
    applet_guid: string;
}